import React, { useState } from 'react';
import { Button, TextField } from '@mui/material';
import Api from '../utils/Api';
import './CategoryCreateForm.css';
import AdminSidebar from './layout/AdminSidebar/AdminSidebar';
import BadgeComponent from './PageProfil/BadgeComponent';

/**
 * Composant du formulaire de création de catégorie
 * 
 * @author Alexandre del Fabbro
 * D'après le code du projet E-Badge
 * Inspiré du code de OpenAi - ChatGPT - [Modèle massif de langage] - chatpgt.com - [Consulté le 27 mars 2025]
 * Inspiré de code de Google - Gemini 2.0 Flash - [Modèle massif de langage] - VSCode Copilot chat - [Consulté le 6 avril 2025]
 */
export default function CategoryCreateForm({ addCategory, errorCategory, handleClose }) {

    const [categoryName, setCategoryName] = useState('');
    const [nameError, setNameError] = useState('');
    const [categoryColor, setCategoryColor] = useState('#FFFFFF');

    const categoryPreviewBadge = {
        title: categoryName || 'Nouvelle catégorie',
        description: '',
        category_color: categoryColor,
        imagePath: null,
        creator_name: '',
        creator_last_name: ''
    };

    const handleCategoryChange = (event) => {
        setCategoryName(event.target.value);
    };

    const handleColorChange = (event) => {
        setCategoryColor(event.target.value);
    };

    const validateName = () => {
        if (categoryName.trim().length === 0) {
            setNameError('Veuillez donner un nom à la catégorie');
            return false;
        }

        setNameError('');
        return true;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!validateName()) return;

        try {
            const formData = new FormData();
            formData.append('name', categoryName);
            formData.append('color', categoryColor);

            const response = await Api.post('/category', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            addCategory(response.data);
            handleClose();
        } catch (error) {
            errorCategory('Erreur lors de la création de la catégorie');
            console.error(error);
        }
    };

    return (
        <div className="category-create-layout">
            <div className="category-create-main-content">
                <AdminSidebar />

                <div className="category-create-form">
                    <h1 className="category-create-form-title">Création d'une catégorie</h1>

                    <div className="category-create-form-card">
                        <form className="create-category" onSubmit={handleSubmit}>
                            <TextField
                                name="name"
                                placeholder="Nom *"
                                variant="outlined"
                                value={categoryName}
                                onChange={handleCategoryChange}
                                onBlur={validateName}
                                error={Boolean(nameError)}
                                helperText={nameError}
                                inputProps={{ maxLength: 45 }}
                                required
                                fullWidth
                            />

                            <label className="category-create-color-picker">
                                <span>Choix de couleur</span>
                                <input
                                    type="color"
                                    value={categoryColor}
                                    onChange={handleColorChange}
                                    aria-label="Choix de couleur"
                                />
                            </label>

                            <div className="category-create-form-button-submit">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    className="category-create-primary-action"
                                    disableRipple
                                >
                                    CRÉER
                                </Button>

                                <Button
                                    type="button"
                                    variant="outlined"
                                    onClick={handleClose}
                                    className="category-create-secondary-action"
                                >
                                    ANNULER
                                </Button>
                            </div>
                        </form>

                        <div className="category-create-preview">
                            <h2 className="category-create-preview-title">Prévisualisation</h2>

                            <div className="category-create-preview-content">
                                <div className="category-create-preview-badge">
                                    <BadgeComponent badge={categoryPreviewBadge} showDetails={false} />

                                    <div className="category-create-preview-badge-title">
                                        {categoryName || "Nouvelle catégorie"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}